<template>
    <apex-chart type="bar" height="350" :options="c_options" :series="c_series"></apex-chart>
</template>

<script>
import ApexChart from 'vue-apexcharts'
import moment from 'moment'
export default {
    props:{
        statistics:Array,
    },
    components:{
        ApexChart,
    },
    data(){
        return{
            colors:["#1F4690","#36AE7C","#EF5B0C","#ff9f43"]
        }
    },
    computed:{
        c_options(){
            let options = {
                chart:{toolbar: {show:false},},
                plotOptions: { bar: { horizontal: false, columnWidth: '55%', }, },
                dataLabels: { enabled: false },
                stroke: { show: true,  width: 2, colors: ['transparent'] },
                xaxis: { categories: this.statistics.map(item=> moment(item.CreateDate).locale("tr").format("L")), },
                yaxis: { labels: { formatter: function(val) { return Number(val) }}},
                tooltip: { y: { formatter: function (val) { return val + "₺" }}},
                fill: { opacity: 1 },
            }
            return options
        },
        c_series(){
            return this.statistics.reduce((arr,item)=>{
                item.VehicleTypeGroupStats.forEach(t=> arr.push(t.VehicleType))
                return arr
            },[]).filter((v,i,s)=>s.indexOf(v)===i).map((sn,index)=>{ 
                return {
                    name:sn,
                    color:this.colors[index > this.colors.length - 1 ? 0 : index],
                    data:this.statistics.reduce((arr,item)=>{
                        let type = item.VehicleTypeGroupStats.find(t=> t.VehicleType===sn)
                        type ? arr.push(parseFloat(type.TotalAmountWithoutTax.replace(".","").replace(",","."))) : arr.push(0)
                        return arr
                    },[])
                }
            })
        }
    }
}
</script>

<style>

</style>